import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M42.268 24 24.743 6.474v9.182c-10.686.772-19.118 9.677-19.118 20.56q.002.593.036 1.176a30.5 30.5 0 0 1 19.082-6.688v10.822z" }) }) })
});
export default SvgShare;
